export default "__VITE_ASSET__DvV8zMkM__"